import axios from "axios";

const buscarPermisosServicios = async () => {
    const token = localStorage.getItem("token");
    const config = {
        headers: {
            Authorization: `${token}`,
        },
    };

    try {
        const response = await axios.get(
            `${process.env.REACT_APP_API_URL}/permisos`,
            config
        );
        return [true, response.data];
    } catch (error) {
        return [false, error.status, error.response.data];
    }
}

const buscarPermisosUsuarioServicios = async (id) => {
    const token = localStorage.getItem("token");
    const config = {
        headers: {
            Authorization: `${token}`,
        },
    };

    try {
        const response = await axios.get(
            `${process.env.REACT_APP_API_URL}/permisos/${id}`,
            config
        );
        return [true, response.data];
    } catch (error) {
        return [false, error.status, error.response.data];
    }
}

export {
    buscarPermisosServicios,
    buscarPermisosUsuarioServicios
}